import React, { JSX } from 'react';
import { InputAdornment, MenuItem, OutlinedInput, Select } from '@mui/material';

// Types
import { StockFilterOption } from '../../../types/Stock';

// Utils
import { StockDetailsContent } from '../../../constants/Constants';
import { ALL, selectMenuProps } from './stockDetails.constants';

// Common Components
import FormInputCollection from '../../common/FormInputCollection/FormInputCollection';

// Assets
import uldTypeIcon from '../../../assets/images/uld-type-icon.svg';

interface StockUldTypeFilterProps {
  value: string;
  options: StockFilterOption[];
  onChange: (value: string) => void;
}

export default function StockUldTypeFilter({ value, options, onChange }: StockUldTypeFilterProps): JSX.Element {
  return (
    <FormInputCollection
      label={StockDetailsContent.uldTypeLabel}
      style={{
        marginRight: '1.5em',
      }}
    >
      <Select
        variant='outlined'
        id='uldGroup'
        name='uldGroup'
        value={value}
        size='small'
        style={{
          width: '150px',
        }}
        onChange={(event) => onChange(event.target.value)}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E2E8F0',
          },
        }}
        MenuProps={selectMenuProps}
        input={
          <OutlinedInput
            startAdornment={
              <InputAdornment position='start'>
                <img src={uldTypeIcon} alt='' aria-hidden='true' />
              </InputAdornment>
            }
          />
        }
      >
        <MenuItem value={ALL}>{StockDetailsContent.allOptionLabel}</MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormInputCollection>
  );
}
